import { toast } from 'react-toastify'
import { IApiCaller } from '../interfaces'


export const apiCaller = async ({
  api,
  apiArguments = null,
  onSuccess,
  onError,
  onEnd,
  onStart,
  toastMessage = true,
  onErrorMessage,
  onSuccessMessage,
}: IApiCaller) => {
  if (onStart) {
    onStart();
  }
  return await api(apiArguments)
    .then((resp) => {
      if (resp.status === 200) {
        if (toastMessage && onSuccessMessage) {
          toast.dismiss();
          toast.success(onSuccessMessage);
        }
        if (onSuccess) {
          onSuccess(resp);
        }
        if (onEnd) onEnd();
        return { data: resp.data, status: resp.status };
      } else {
        if (toastMessage && onErrorMessage) {
          toast.dismiss();
          toast.error(onErrorMessage);
        }
        if (resp.response?.data?.errors.length !== 0) {
            toast.error(resp.response.data.errors[0]);
          }
        if (onEnd) onEnd();
        return { data: null, status: resp.status };
      }
    })
    .catch((ex) => {
      if (toastMessage && onErrorMessage) {
        toast.dismiss();
        toast.error(onErrorMessage);
      }
      if (onError) {
        onError(ex);
      }
      if (ex.response?.data?.errors.length !== 0 && toastMessage) {
        toast.error(ex.response.data.errors[0]);
      }
      if (onEnd) onEnd();
      return { data: null, status: ex?.response?.status };
    });
};

